/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { useGetAdyenAccountHolderStores } from "../../service/adyen-account-holders-api";
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { EmptyState } from "../../../../components/EmptyState";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";
import { SpinnerBlock } from "../../../common/Spinner";
import { AdyenAccountHolderStoresTable } from "./AdyenAccountHolderStoresTable";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const AdyenAccountHolderStores = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: stores, isLoading } = useGetAdyenAccountHolderStores(id);

  if (isLoading || !stores) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="Stores"
        subtitle="Manage all of your stores for this account holder"
      >
        <ButtonInternalLink
          to={routes.adyenAccountHolderStoresNew(organizationKeyName, id)}
        >
          Create new store
        </ButtonInternalLink>
      </PageHeader>
      {stores.length === 0 ? (
        <>
          <Divider />
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No stores created yet"
              subtitle="Click in the top right corner to create your first new store."
            />
          </CardBody>
        </>
      ) : (
        <div>
          <AdyenAccountHolderStoresTable stores={stores} />
          <PageFooter>
            <StyledText className="bodyTextRegular mb-0">
              {stores.length} {stores.length === 1 ? "store" : "stores"} in
              total
            </StyledText>
          </PageFooter>
        </div>
      )}
    </CardContainer>
  );
};
